import { addDoc, collection, doc, serverTimestamp } from "firebase/firestore";
import { db } from "@poseidon/firebase/firebase";
import { uploadFile } from "@poseidon/firebase/storage";

export const addFiles = async ({
  fileCategory,
  fileGroup,
  files: filesWithFilePurposes,
  user,
  applicationId,
  agreementId,
  sailorId,
  dealerId,
  asDealer,
}) => {
  for (let obj of filesWithFilePurposes) {
    const { file, filePurpose } = obj;
    const uploadPath = await uploadFile({
      file: file,
      path: `users/${user.uid}/${file.name}`,
      metadata: {
        contentType: file.type,
        uploadedBy: user.uid,
      },
    });

    await addDoc(collection(db, "files"), {
      name: file.name,
      type: file.type,
      size: file.size,
      ...(applicationId && {
        application: doc(db, "applications", applicationId),
      }),
      ...(agreementId && {
        agreement: doc(db, "agreements", agreementId),
      }),
      ...(sailorId && {
        sailor: doc(db, "sailors", sailorId),
      }),
      ...(dealerId && {
        dealer: doc(db, "dealers", dealerId),
      }),
      uploadPath,
      fileCategory,
      fileGroup,
      filePurpose: filePurpose,
      uploadedBy: doc(db, asDealer ? "dealers" : "admins", user.uid),
      createdAt: serverTimestamp(),
    });
  }
};
